import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1979252c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "cell" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "cell" }
const _hoisted_23 = {
  key: 0,
  class: "zone_code"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zone_divider" }, null, -1 /* HOISTED */))
const _hoisted_26 = {
  key: 4,
  class: "code_btn"
}
const _hoisted_27 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_28 = {
  key: 0,
  class: "label"
}
const _hoisted_29 = {
  key: 1,
  class: "label"
}
const _hoisted_30 = { class: "cell" }
const _hoisted_31 = { class: "to_pass" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "yuedubox" }
const _hoisted_34 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClose()))
    }, [
      _createVNode(_component_van_icon, {
        class: "icon",
        size: "14px",
        name: "cross"
      })
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.t('me.welcome') + " " + $setup.appName), 1 /* TEXT */),
    _createCommentVNode(" <p class=\"desc\">{{ t('me.logintips') }}</p> "),
    ($setup.isRegisterMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" 输入手机号，调起手机号键盘 "),
            _createElementVNode("p", _hoisted_5, _toDisplayString($setup.t("me.zhen")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_field, {
                modelValue: $setup.account,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (($setup.account) = $event)),
                  $setup.checkText
                ],
                type: "text",
                placeholder: $setup.t('me.inputaccount'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createCommentVNode(" 密码 "),
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.t("me.mm")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_field, {
                modelValue: $setup.password,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event)),
                  $setup.checkText
                ],
                type: "password",
                placeholder: $setup.t('me.inputpassword'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createCommentVNode(" 确认密码 "),
            _createElementVNode("p", _hoisted_11, _toDisplayString($setup.t("me.querenpwd")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_van_field, {
                modelValue: $setup.password2,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (($setup.password2) = $event)),
                  $setup.checkText
                ],
                type: "password",
                placeholder: $setup.t('me.inputpasswordagain'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createCommentVNode(" 昵称 "),
            _createElementVNode("p", _hoisted_14, _toDisplayString($setup.t("me.username")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_van_field, {
                modelValue: $setup.nickname,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => (($setup.nickname) = $event)),
                  $setup.checkText
                ],
                type: "text",
                placeholder: $setup.t('me.inputnickname'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createCommentVNode(" 设置邮箱 "),
            _createElementVNode("p", _hoisted_17, _toDisplayString($setup.t("设置邮箱（用于找回密码，可选）")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_field, {
                modelValue: $setup.email,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => (($setup.email) = $event)),
                  $setup.checkText
                ],
                type: "text",
                placeholder: $setup.t('请输入邮箱'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createCommentVNode(" 输入手机号，调起手机号键盘 "),
            _createElementVNode("p", _hoisted_21, _toDisplayString($setup.currLoginMode == $setup.LoginMode.SMS ? $setup.t("me.phone") : $setup.t("me.zhen")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_22, [
              ($setup.currLoginMode == $setup.LoginMode.SMS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_van_field, {
                      modelValue: $setup.zone,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => (($setup.zone) = $event)),
                        $setup.checkText
                      ],
                      type: "number",
                      placeholder: $setup.app_country=='vi'? '84': '62',
                      class: "zone_input"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                    _hoisted_25
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.currLoginMode == $setup.LoginMode.SMS)
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 1,
                    modelValue: $setup.account,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => (($setup.account) = $event)),
                      $setup.checkText
                    ],
                    type: "tel",
                    placeholder: $setup.t('me.inputphone'),
                    class: "input"
                  }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
                : (_openBlock(), _createBlock(_component_van_field, {
                    key: 2,
                    modelValue: $setup.account,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => (($setup.account) = $event)),
                      $setup.checkText
                    ],
                    type: "text",
                    placeholder: $setup.t('me.inputaccount'),
                    class: "input"
                  }, null, 8 /* PROPS */, ["modelValue", "placeholder"])),
              ($setup.currLoginMode === $setup.LoginMode.SMS && $setup.codeShow)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    onClick: $setup.initCaptcha,
                    class: "code_btn"
                  }, _toDisplayString(_ctx.$t("me.hqyzm")), 1 /* TEXT */))
                : ($setup.currLoginMode === $setup.LoginMode.SMS)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.count) + "s", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            ($setup.currLoginMode == $setup.LoginMode.SMS)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($setup.t('me.code')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.t('me.mm')), 1 /* TEXT */)),
            _createElementVNode("div", _hoisted_30, [
              ($setup.currLoginMode == $setup.LoginMode.SMS)
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 0,
                    modelValue: $setup.sms,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = ($event: any) => (($setup.sms) = $event)),
                      $setup.checkText
                    ],
                    center: "",
                    clearable: "",
                    class: "input",
                    placeholder: $setup.t('me.dxyzm')
                  }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" <div v-else> "),
                    _createVNode(_component_van_field, {
                      modelValue: $setup.password,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => (($setup.password) = $event)),
                        $setup.checkText
                      ],
                      type: "password",
                      center: "",
                      clearable: "",
                      placeholder: $setup.t('me.srmi'),
                      class: "input"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
              ($setup.currLoginMode == $setup.LoginMode.PASSWORD)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: "forget-password-class",
                    onClick: $setup.forGetPasswordAction
                  }, _toDisplayString(_ctx.$t('忘记密码？')), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" </div> ")
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_31, [
      ($setup.isRegisterMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32))
        : ($setup.currLoginMode == $setup.LoginMode.SMS)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.currLoginMode = $setup.LoginMode.PASSWORD))
            }, _toDisplayString(_ctx.$t("me.symmdl")), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.currLoginMode = $setup.LoginMode.SMS))
            }, _toDisplayString(_ctx.$t("me.yzmdl")), 1 /* TEXT */)),
      _createCommentVNode(" 去注册，去登录 "),
      _createElementVNode("div", {
        onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.isRegisterMode = !$setup.isRegisterMode))
      }, _toDisplayString($setup.isRegisterMode ? _ctx.$t("me.gotoLogin") : _ctx.$t("me.gotoRegister")), 1 /* TEXT */)
    ]),
    ($setup.isRegisterMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: $setup.doRegister,
          class: "login_btn",
          block: ""
        }, _toDisplayString(_ctx.$t("me.register")), 1 /* TEXT */))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          onClick: $setup.doLogin,
          class: "login_btn",
          block: ""
        }, _toDisplayString(_ctx.$t("me.dl")), 1 /* TEXT */)),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_van_checkbox, {
        modelValue: $setup.checked,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.checked) = $event)),
        "icon-size": "16px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('me.wyydbty')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createCommentVNode(" /download/serviceAgreement_b.html "),
      _createElementVNode("a", {
        class: "xieyi",
        target: "_blank",
        href: $setup.xyData
      }, _toDisplayString(_ctx.$t('me.rjfwyx')), 9 /* TEXT, PROPS */, _hoisted_34)
    ])
  ]))
}